import { Heading } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const ReloadBanner = () => {
  const { t: generalTranslations } = useTranslation(NAMESPACE.GENERAL)

  return (
    <StyledWrapper>
      <StyledHeading level={3}>
        {generalTranslations(generalConstants.Reload)}
      </StyledHeading>
      <div onClick={() => window.location.reload()}>
        <StyledHeadingClick level={3}>
          {generalTranslations(generalConstants.ClickHere)}
        </StyledHeadingClick>
      </div>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  background-color: ${(props) => props.theme.color.status.popout} !important;
  min-height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    flex-direction: column;
    padding: 5px;
  }
`

const StyledHeading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color11} !important;
  font-size: 18px;
  text-align: center;
`

const StyledHeadingClick = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color11} !important;
  font-size: 18px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 5px;
`
